function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpCircle = function SvgHelpCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.05 12a7.25 7.25 0 1 1-14.5 0 7.25 7.25 0 0 1 14.5 0Z",
    stroke: props.color,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.55 10s.25-2.25 2.25-2.25S15.05 9 15.05 10c0 .751-.423 1.503-1.27 1.83-.515.199-.98.618-.98 1.17v.25",
    stroke: props.color,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3 16a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z",
    stroke: props.color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export { SvgHelpCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjA1IDEyQzIwLjA1IDE2LjAwNDEgMTYuODA0MSAxOS4yNSAxMi44IDE5LjI1QzguNzk1OTggMTkuMjUgNS41NTAwNSAxNi4wMDQxIDUuNTUwMDUgMTJDNS41NTAwNSA3Ljk5NTk0IDguNzk1OTggNC43NSAxMi44IDQuNzVDMTYuODA0MSA0Ljc1IDIwLjA1IDcuOTk1OTQgMjAuMDUgMTJaIiBzdHJva2U9IiMxMTEwMTIiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjU1IDEwQzEwLjU1IDEwIDEwLjggNy43NSAxMi44IDcuNzVDMTQuOCA3Ljc1IDE1LjA1IDkgMTUuMDUgMTBDMTUuMDUgMTAuNzUxMyAxNC42MjY3IDExLjUwMjcgMTMuNzc5OSAxMS44Mjk5QzEzLjI2NDcgMTIuMDI4OSAxMi44IDEyLjQ0NzcgMTIuOCAxM1YxMy4yNSIgc3Ryb2tlPSIjMTExMDEyIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMy4zIDE2QzEzLjMgMTYuMjc2MSAxMy4wNzYyIDE2LjUgMTIuOCAxNi41QzEyLjUyMzkgMTYuNSAxMi4zIDE2LjI3NjEgMTIuMyAxNkMxMi4zIDE1LjcyMzkgMTIuNTIzOSAxNS41IDEyLjggMTUuNUMxMy4wNzYyIDE1LjUgMTMuMyAxNS43MjM5IDEzLjMgMTZaIiBzdHJva2U9IiMxMTEwMTIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";